import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';

@customElement('gz-enumeration-icon')
export class GzEnumerationIconWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  value: string;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="d-flex flex-row align-items-baseline">
        <div class="circle d-flex justify-center align-items-center">
          <span>${this.value}</span>
        </div>
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-enumeration-icon': GzEnumerationIconWebComponent;
  }
}
